import { Component } from "react";
import styled from "@emotion/styled"

const TitleContainer = styled.div`
  display: inline-flex;
  margin-bottom: 0.5em;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    margin-bottom: 0;
`;

const Logo = styled.div`
  background-image: url("//dcpd6wotaa0mb.cloudfront.net/owenscorning.com/assets/roofing/oc-logo-8a618413fbb8004fd179746dedda8755aea61e6308a58c973a24d38bdf389616.svg");
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  height: 72px;
  margin-right: 10px;
  position: relative;
  width: 72px;
`;

const TitleWrap = styled.div`
  display: inline-flex;
  flex-direction: column;
  position: relative;
  width: calc(100% - 80px);
  justify-content: end;
`;

const PreTitle = styled.div`
  color: #585858;
  font-family: "OCRoboto";
  letter-spacing: 0.01em;
  line-height: 1.125em;
  margin-bottom: 0.25em;
`;

const Title = styled.div`
  border-bottom: 2px solid;
  color: #000000;
  font-family: "Oswald";
  font-size: 28px;
  line-height: 30px;
  margin-bottom: 0.15em;
  padding-bottom: 0.5em;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 26px;
  }
`;

export default class SelectedTitle extends Component {
  render() {
    return (
      <TitleContainer>
        <Logo />
        <TitleWrap>
          {this.props.trudefinition && (
            <PreTitle> TruDefinition®</PreTitle>
          )}
          <Title 
            className="selected-color-name jsSwatchName"
            trudefinition={this.props.trudefinition}
          >
            {this.props.shingleName} Shingles
          </Title>
        </TitleWrap>
      </TitleContainer>
    );
  }
}
